export default "__VITE_ASSET__CG9PnoXE__"